// updateEventStatus
import { createSlice } from "@reduxjs/toolkit";
import { updateEventStatus } from "../../actions/events/updateEventStatus";

const initialState = {
  data: [],
  loading: false,
  error: null,
};

const updateEventStatusSlice = createSlice({
  name: "updateEventStatus",
  initialState,
  reducers: {
    clearupdateEventStatusState: (state) => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateEventStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateEventStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(updateEventStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearupdateEventStatusState } = updateEventStatusSlice.actions;
export default updateEventStatusSlice.reducer;
